// Version information that is produced by the build system

const vi = '1.1.5.prod_36424'

export default vi



// WEBPACK FOOTER //
// ./src/versionInfo.js